import React, {useContext} from "react";
import "./Publications.scss";
import {publicationsSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function Publications() {
  const {isDark} = useContext(StyleContext);
  if (!publicationsSection.display) {
    return null;
  }

  function openUrlInNewTab(url) {
    if (!url) {
      return;
    }
    var win = window.open(url, "_blank");
    win.focus();
  }

  return (
    <Fade bottom duration={500} distance="10px">
      <div className="main" id="publications">
        <div className="publications-main-div">
          <div className="publications-header">
            <h1
              className={
                isDark
                  ? "dark-mode heading publications-heading"
                  : "heading publications-heading"
              }
            >
              {publicationsSection.title}
            </h1>
            <p
              className={
                isDark
                  ? "dark-mode subTitle publications-subtitle"
                  : "subTitle publications-subtitle"
              }
            >
              {publicationsSection.subtitle}
            </p>
            <div className="publications-link-div">
              <span
                className={
                  isDark ? "dark-mode publications-link" : "publications-link"
                }
                onClick={() => openUrlInNewTab(publicationsSection.googleScholarLink)}
              >
                View My Google Scholar Profile
              </span>
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
}

